import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getFirstLetter } from "../../../getFirstLetter";
import { selectUser } from "../../../redux/Slices/userSlice";

function UserInfo() {

  const user = useSelector(selectUser);

  // let user;
  // try {
  //   user = JSON.parse(userState);
  // } catch (e) {
  //   user = null;
  // }

  // const parsedData = JSON.parse(userInfoData);
  // const name = userInfodataLs?.name || userInfodataLs?.name;
  // const userPhone = userInfodataLs?.phone?.substring(3) || userInfodataLs?.phone.substring(3);

  return (
    <Fragment>
      
      <Link to='/account/your-profile' className="p_inf">
        <div>
          <div className="user_info_prfl_pctr">
            <div>{getFirstLetter(user?.name)}</div>
          </div>
          <div>
            <h4>
              <span className="userInfo_hlw">Hello</span>
              <span className="userInfo_name">{user?.name}</span>
            </h4>
            <span className="u_inf_phno">{user?.phone}</span> 
          </div>
        </div>
      </Link>
    </Fragment>
  );
}

export default UserInfo;
